import MenuItem from "../components/MenuItem.vue";
export default {
  name: "MenuComponent",
  components: {
    MenuItem
  },
  data() {
    return {
      menuItems: [{
        path: "/records",
        icon: "fas fa-file-alt",
        altText: "Caisse",
        caption: "Enregistrement<br />Modification<br />Consultation",
        iconColor: "#007bff",
        hoverColor: "#007bff"
      }, {
        path: "/records_printing",
        icon: "fas fa-print",
        altText: "Imprimante",
        caption: "Impression",
        iconColor: "#28a745",
        hoverColor: "#28a745"
      }, {
        path: "/remises",
        icon: "fas fa-percentage",
        altText: "Réduction",
        caption: "Remises",
        iconColor: "#ffc107",
        hoverColor: "#ffc107"
      }, {
        path: "/salaries",
        icon: "fas fa-wallet",
        altText: "Portefeuille",
        caption: "Registre des Salaires",
        iconColor: "#dc3545",
        hoverColor: "#dc3545"
      }, {
        path: "/details",
        icon: "fas fa-search",
        altText: "Loupe",
        caption: "Détails des caisses",
        iconColor: "#17a2b8",
        hoverColor: "#17a2b8"
      }, {
        path: "/hr",
        icon: "fas fa-users-cog",
        altText: "Employés",
        caption: "Ressources Humaines",
        iconColor: "#343a40",
        hoverColor: "#343a40"
      },
      // New menu item for café items
      {
        path: "/CafeMenu",
        icon: "fas fa-coffee",
        altText: "Café",
        caption: "Gestion des Articles du Café",
        iconColor: "#6f42c1",
        // Purple example
        hoverColor: "#6f42c1" // Purple shadow
      }]
    };
  }
};